import React from "react";
import { ButtonIcon, ButtonText } from "@loanbossinc/component-library";

const FPHeader = ({
  filterPanelSaveAndClearAreEnabled,
  onClose: handleOnCloseClicked,
  onSave,
  onShowPresets: handleOnShowPresetsClicked,
  presets,
  onClearFilters: handleOnClearFiltersClicked
}) => (
  <div className="fp-header-wrapper">
    <div className="fp-header-close-button-wrapper">
      <ButtonIcon iconName="close" onClick={handleOnCloseClicked} />
      {filterPanelSaveAndClearAreEnabled && <ButtonText label="Clear Filters" onClick={handleOnClearFiltersClicked} />}
    </div>
    <div className="fp-header-show-save-button-wrapper">
      {!filterPanelSaveAndClearAreEnabled && <ButtonText label="Show saved filters" onClick={handleOnShowPresetsClicked} disabled={presets.length === 0} />}
      {filterPanelSaveAndClearAreEnabled && <ButtonText className="deal-screener-buttons" label="Save" onClick={onSave} />}
    </div>
  </div>
);

export default FPHeader;
